import React, { ReactNode } from 'react';
import { Icon, InlineLink, Tooltip } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import { useFlags } from '@fullstory/react-hooks';
import { Flag } from '@fullstory/proto/fs/shared/flags';

type PageNodeDefinedInfoProps = {
  size?: React.ComponentPropsWithoutRef<typeof Icon>['size'];
  viewMetric?: () => void;
};

export const PageNotDefinedInfo = ({ size = 20, viewMetric }: PageNodeDefinedInfoProps) => {
  const flags = useFlags();
  const nativeMobile = flags.hasBit(Flag.FeatNativeMobile);
  const defaultTooltipMessage = intl.formatMessage(
    {
      defaultMessage:
        "The URLs in this group haven't been defined as Pages. <link>View URLs as Metric.</link>",
      id: 'VWeER/',
    },
    {
      link(text: ReactNode) {
        return viewMetric ? <InlineLink onClick={viewMetric}>{text}</InlineLink> : null;
      },
    },
  );

  const nativeMobileTooltipMessage = intl.formatMessage(
    {
      defaultMessage:
        "The Pages or URLs in this group haven't been defined. Explore the Pages and URLs that are not defined <link>as a Metric.</link>",
      id: 'vc/Fna',
    },
    {
      link(text: ReactNode) {
        return (
          <InlineLink
            href="https://help.fullstory.com/hc/en-us/articles/360052331173-Pages-in-Fullstory#01FE48A345B2W99CHQVWWV0ZJB"
            newTab
          >
            {text}
          </InlineLink>
        );
      },
    },
  );
  return (
    <Tooltip
      data-component="PageNotDefinedInfo"
      tooltipContent={nativeMobile ? nativeMobileTooltipMessage : defaultTooltipMessage}
    >
      <Icon color="secondary" name="information" size={size} />
    </Tooltip>
  );
};
